import React from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import get from 'lodash/get';

const SingleFieldListCustom = ({
    source,
    optionText = 'name',
    separator = ', ',
}) => {
    const record = useRecordContext();
    const data = get(record, source);

    if (!data || !Array.isArray(data)) {
        return null;
    }

    return (
        <span>
            {data.map((item) => (typeof optionText === 'function' ? optionText(item) : get(item, optionText))).join(separator)}
        </span>
    );
};

SingleFieldListCustom.propTypes = {
    source: PropTypes.string.isRequired,
    optionText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    separator: PropTypes.string,
};

export default SingleFieldListCustom;
